import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { tinResponseProps } from '../../../../models/custom-tin-input-responses.model';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getUsePrefetchFieldConfig,
  getPopulateRelativeToRootFieldConfig,
  getPopulatesPropsSettingsConfigFormly,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  getTinFieldSettingsConfig,
  tinFieldParseIntoSettingsFormModel,
  tinFieldUpdateFromSettingsFormModel,
} from '../custom-tin-input.configuration';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomTinInputFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = {
      ...fieldsBaseConfigurationFormModel(),
      endpointCode: 'FTINDETAILS',
    };
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getTinFieldSettingsConfig(),
      getUsePrefetchFieldConfig(this.formBuilderService),
      getPopulateRelativeToRootFieldConfig(),
      ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, [
        ...Array.from(tinResponseProps),
      ]),
    ];
    this.availableValidations.push('invalidInput', 'invalidTIN');
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return tinFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return tinFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
